// This is an old way of styling the map.
// It is possible to create new style instance in the google cloud console and use the `mapId` prop to apply the style.

// export const globeMapStyles = [
//   {
//     featureType: 'administrative',
//     elementType: 'geometry.stroke',
//     stylers: [
//       {
//         color: '#ffffff',
//       },
//     ],
//   },
//   {
//     featureType: 'landscape',
//     elementType: 'all',
//     stylers: [
//       {
//         saturation: '-65',
//       },
//       {
//         lightness: '-13',
//       },
//       {
//         gamma: '1.00',
//       },
//       {
//         hue: '#ffd500',
//       },
//     ],
//   },
//   {
//     featureType: 'landscape',
//     elementType: 'geometry.stroke',
//     stylers: [
//       {
//         color: '#ffffff',
//       },
//     ],
//   },
//   {
//     featureType: 'water',
//     elementType: 'all',
//     stylers: [
//       {
//         saturation: '-72',
//       },
//       {
//         lightness: '39',
//       },
//       {
//         gamma: 1,
//       },
//       {
//         color: '#cededa',
//       },
//     ],
//   },
//   {
//     featureType: 'poi',
//     stylers: [
//       {
//         visibility: 'off',
//       },
//     ],
//   },
// ];

var globeMapStyles = [{
  featureType: 'administrative',
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#ffffff'
  }]
}, {
  featureType: 'administrative.country',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }, {
    hue: '#ff0000'
  }]
}, {
  featureType: 'administrative.country',
  elementType: 'geometry.stroke',
  stylers: [{
    visibility: 'on'
  }, {
    hue: '#ff3900'
  }]
}, {
  featureType: 'administrative.province',
  elementType: 'geometry.fill',
  stylers: [{
    hue: '#ff0000'
  }]
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    saturation: '-65'
  }, {
    lightness: '-13'
  }, {
    gamma: '1.00'
  }, {
    hue: '#ffd500'
  }]
}, {
  featureType: 'landscape',
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#ffffff'
  }]
}, {
  featureType: 'landscape.man_made',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#e8e2d6'
  }]
}, {
  featureType: 'landscape.natural.landcover',
  elementType: 'geometry.fill',
  stylers: [{
    hue: '#ffa300'
  }]
}, {
  featureType: 'landscape.natural.landcover',
  elementType: 'labels.text.fill',
  stylers: [{
    hue: '#ff0000'
  }]
}, {
  featureType: 'landscape.natural.terrain',
  elementType: 'labels.text.fill',
  stylers: [{
    hue: '#ff0000'
  }]
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'simplified'
  }, {
    hue: '#ff0000'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.stroke',
  stylers: [{
    visibility: 'on'
  }, {
    hue: '#ff9500'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#c0af89'
  }]
}, {
  featureType: 'road.local',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#9e8656'
  }]
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{
    saturation: '-72'
  }, {
    lightness: '39'
  }, {
    gamma: 1
  }, {
    color: '#cededa'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry.fill',
  stylers: [{
    saturation: '1'
  }, {
    gamma: '2.33'
  }, {
    lightness: '-25'
  }, {
    color: '#d8ebe6'
  }]
}];

export { globeMapStyles };
//# sourceMappingURL=mapStyles.js.map
